import cn from 'classnames';
import React from 'react';
import { useAppSelector } from 'src/app/redux/createAction';
import s from 'src/entities/Menu/ui/NavItem/NavItem.module.scss';
import { DashBoardMenuName, SingleMenuItem } from 'src/pages/CompanyPage/_BLL/types';
import { RequestStatus } from 'src/shared/api/types';
import { ButtonPrimary } from 'src/shared/ui/_buttons/ButtonPrimary';

const checkIfActive = (menuItemName: DashBoardMenuName, activeMenuItem: DashBoardMenuName) => menuItemName === activeMenuItem;
const checkIfDisabled = (menuItemName: DashBoardMenuName, activeMenuItem: DashBoardMenuName) =>
	activeMenuItem === DashBoardMenuName.welcome && menuItemName !== DashBoardMenuName.welcome;

export type SetActiveMenuItem = (menuItemName: DashBoardMenuName) => void;

interface Props extends SingleMenuItem {
	index: number;
	onClick: SetActiveMenuItem;
	activeMenuItem: DashBoardMenuName;
}

export const NavItem: React.FC<Props> = (props) => {
	const {
		index, //
		name,
		value,
		totalValue,
		activeMenuItem,
		onClick,
	} = props;

	// * Selectors
	const status = useAppSelector((state) => state.company.status);
	const formHaveErrors = useAppSelector((state) => state.company.formHaveErrors);

	const isActiveMenu = checkIfActive(name, activeMenuItem);
	const isDisabled = checkIfDisabled(name, activeMenuItem) || formHaveErrors || status === RequestStatus.loading;

	// * Render
	return (
		<>
			{name === DashBoardMenuName.submitForRating ? (
				<ButtonPrimary
					style={{ width: '100%' }}
					onClick={() => onClick(name)}
					disabled={isDisabled}
				>
					{DashBoardMenuName.submitForRating}
				</ButtonPrimary>
			) : (
				<div
					className={cn(
						s.container, //
						isActiveMenu && s.container_active,
						isDisabled && s.container_disabled,
					)}
					onClick={() => onClick(name)}
				>
					{name !== DashBoardMenuName.welcome && <span>{`S.${index} `}</span>}
					<span className={s.name}>{`${name} `}</span>
					{value !== null && <span>{`(${value}`}</span>}
					{totalValue && <span>{`/${totalValue}`}</span>}
					{value !== null && <span>{')'}</span>}
				</div>
			)}
		</>
	);
};
